// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".css?v=" + {"917":"673c971c8f7f37aed928","3811":"462aaa7f83ade48e4465"}[chunkId] + "";
};